export default "__VITE_ASSET__BAy9xDnw__"